module.exports = __webpack_public_path__ + "static/media/us.5b6fdf18.png";